module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Leave-Credit/bulk-leave-credit-approval/bulk-leave-credit-approval.component.css
// module id = ./src/app/hrms/Leave-Credit/bulk-leave-credit-approval/bulk-leave-credit-approval.component.css
// module chunks = main